import { z } from 'zod'

export const memoSchema = z.object({
  memo: z.string().optional(),
})

export type MemoFormValues = z.input<typeof memoSchema>
